var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-0"},[_c('iframe',{attrs:{"height":"40","width":"100%","scrolling":"no","src":`${_vm.getIframePath()}/c/etc/OneDrivePicker.php?linkColor=%23646464&hoverColor=white&fontSize=16px&iconSize=16${_vm.langAndDirString()}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }